<dashboard-dialog-frame [icon]='icon()' [header]='header()' [actions]='[]' [dialogRef]='dialogRef'>
	<div class="event-dialog">
		<div class='timezone-message'>
			<small>All times are local to {{timezone}}.</small>
		</div>
		<kendo-tabstrip class="h-100 p-2">
			<kendo-tabstrip-tab title="Add" [selected]="true">
				<ng-template kendoTabContent>
					<readonly-access [readonly]="isReadonly()"></readonly-access>
					<event-dialog-add-part (closeDialog)="close()"></event-dialog-add-part>
				</ng-template>
			</kendo-tabstrip-tab>
		</kendo-tabstrip>
	</div>
</dashboard-dialog-frame>